export const GOOGLE_CLIENT_ID = '189053781471-tsm9j66gn95h7t3r9cm9erhfcbs5c2gb.apps.googleusercontent.com';
export const GOOGLE_API_KEY = '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';
